<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('whiteLabel')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <div
                class="uk-grid uk-grid-divider uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1"
                uk-grid>
                <div>
                    <TextField
                        v-model="titleField.value"
                        :autocomplete="titleField.autocomplete"
                        :autofocus="titleField.autofocus"
                        :hasPasswordMeter="titleField.hasPasswordMeter"
                        :icon="titleField.icon"
                        :is-optional="titleField.optional"
                        :label="titleField.label"
                        :name="titleField.name"
                        :options="titleField.options"
                        :rules="titleField.rules"
                        :steps="titleField.steps"
                        :type="titleField.type"
                        :on-enter="actionDeclare"
                        :validate="validationTrigger"
                        @setValid="setValid" />

                    <div class="uk-margin-medium-top" />
                    <SwitchButton
                        :id="'clickandbuy-switch-active-' + this.clickAndBuy.id"
                        v-model="isActive"
                        :label="$t('active')"
                        @input="success = false" />

                    <div class="uk-margin-medium-top" />
                    <CurrencyInput
                        v-model="priceField.value"
                        :icon="priceField.icon"
                        :label="priceField.label"
                        :name="priceField.name"
                        :options="computedCurrencyOptions"
                        :rules="priceField.rules"
                        :validate="trigger" />

                    <div class="uk-margin-medium-top" />
                    <ClickAndBuyMediaForm
                        v-if="settings && settings.clickAndBuyInfos"
                        :id="id"
                        :data="newClickAndBuy.mediaFileId"
                        @file="setMediaFile"
                        :allowed-size="
                            settings.clickAndBuyInfos.mediaFileSizeBytes
                        "
                        :allowed-extensions="
                            settings.clickAndBuyInfos.mediaFileExtensions
                        "
                        :disabled="disabled" />

                    <div class="uk-margin-medium-top" />
                    <LabelWithError
                        :error="fileError"
                        :label="$t('file') + ' (' + $t('optional') + ')'" />
                    <div class="uk-hidden" uk-form-custom>
                        <input
                            :id="'clickandbuy-file' + this.id"
                            :ref="'clickandbuyfile' + this.id"
                            type="file"
                            v-on:change="fileHandleDrop()"
                            v-on:click="
                                $refs['clickandbuyfile' + id].value = null
                            " />
                    </div>

                    <div v-if="newClickAndBuy.articleFileId">
                        <div
                            :id="'clickandbuy-file-upload' + this.id"
                            class="js-upload uk-placeholder uk-text-center">
                            <div class="uk-inline clickandbuy-file-struct">
                                <div class="uk-position-top-right">
                                    <div class="uk-grid-small" uk-grid>
                                        <div>
                                            <span
                                                class="cursor-pointer"
                                                v-on:click="
                                                    actionFileTriggerInput()
                                                ">
                                                <Icon
                                                    :uk-tooltip="
                                                        'title:' + $t('replace')
                                                    "
                                                    icon="upload" />
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                class="cursor-pointer"
                                                v-on:click="
                                                    actionArticleFileDownload()
                                                ">
                                                <Icon
                                                    :uk-tooltip="
                                                        'title:' +
                                                        $t('download')
                                                    "
                                                    icon="cloud-download" />
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                class="cursor-pointer"
                                                v-on:click="actionFileDelete()">
                                                <Icon
                                                    :uk-tooltip="
                                                        'title:' + $t('delete')
                                                    "
                                                    icon="trash" />
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <Icon
                                        :ratio="2.2"
                                        class="upload-icon"
                                        icon="bag" />
                                </div>
                                <div class="uk-text-middle file-name">
                                    <span
                                        v-if="newClickAndBuy.articleFileId.name"
                                        :uk-tooltip="
                                            'title:' +
                                            newClickAndBuy.articleFileId.name
                                        ">
                                        {{ newClickAndBuy.articleFileId.name }}
                                    </span>
                                    <span
                                        :uk-tooltip="
                                            'title:' +
                                            newClickAndBuy.articleFileId
                                        "
                                        v-else>
                                        {{ newClickAndBuy.articleFileId }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div
                            :id="'clickandbuy-file-upload' + this.id"
                            class="js-upload uk-placeholder uk-placeholder-hover uk-text-center cursor-pointer"
                            v-on:click="actionFileTriggerInput()">
                            <div>
                                <Icon
                                    :ratio="2.2"
                                    class="upload-icon"
                                    icon="cloud-upload" />
                            </div>

                            <span class="uk-text-middle">{{
                                $t('x.drop.or.', {
                                    x: $t('file'),
                                })
                            }}</span>
                            <span class="uk-link uk-text-middle">{{
                                $t('select')
                            }}</span>

                            <div
                                v-if="clickAndBuyFileError"
                                class="uk-margin-top" />
                            <LabelWithError
                                v-if="clickAndBuyFileError"
                                :error="clickAndBuyFileError"
                                :label="$t('file')" />
                        </div>
                    </div>
                </div>
                <div>
                    <LabelWithError is-optional :label="$t('description')" />
                    <vue-editor
                        v-model="newClickAndBuy.text"
                        v-on:input="success = false" />

                    <div class="uk-margin-medium-top" />
                    <LabelWithError
                        is-optional
                        :label="$t('clickandbuy.email.text')" />

                    <vue-editor
                        v-model="newClickAndBuy.emailText"
                        v-on:input="success = false" />
                </div>
            </div>

            <div class="uk-margin-medium-bottom" />

            <div uk-grid>
                <div v-if="newClickAndBuy.id" class="uk-width-auto">
                    <div class="uk-button-group">
                        <div class="uk-inline">
                            <span
                                :uk-tooltip="
                                    'title:' + $t('x.delete', {x: $t(title)})
                                ">
                                <Button is-large is-max mode="danger">
                                    <Icon icon="trash" />
                                </Button>
                            </span>
                            <div
                                uk-dropdown="mode: click; target: !.uk-button-group;">
                                <ul class="uk-nav uk-dropdown-nav">
                                    <Translate
                                        translation-key="clickandbuy.delete.message" />
                                    <div class="uk-margin-small-top" />

                                    <Button
                                        :action="actionDelete"
                                        :is-loading="deleteLoading"
                                        has-action
                                        is-large
                                        is-max
                                        mode="danger">
                                        <Translate translation-key="delete" />
                                    </Button>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-width-expand">
                    <Button
                        :action="actionDeclare"
                        :is-loading="loading"
                        :text="
                            $t(newClickAndBuy.id ? 'x.change' : 'x.add', {
                                x: $t(title),
                            })
                        "
                        has-action
                        is-large
                        is-max
                        mode="primary" />
                </div>
            </div>

            <div v-if="error" class="uk-margin-medium-bottom" />
            <ErrorMessage :error="error" />

            <div v-if="success" class="uk-margin-medium-bottom" />
            <SuccessMessage
                :success="success"
                :message="$t('x.changes.saved', {x: $t(title)})" />
        </span>
    </span>
</template>

<script>
import SuccessMessage from '@/components/generic/SuccessMessage.vue';
import Button from '@/components/generic/Button.vue';
import TextField from '@/components/generic/TextField.vue';
import ErrorMessage from '@/components/generic/ErrorMessage.vue';
import axios from 'axios';
import Icon from '@/components/generic/Icon.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';
import {VueEditor} from 'vue2-editor';
import CurrencyInput from '@/components/generic/CurrencyInput.vue';
import ClickAndBuyMediaForm from '@/views/clickandbuy/ClickAndBuyMediaForm.vue';
import SwitchButton from '@/components/generic/SwitchButton.vue';
import UIkit from 'uikit';
import VueCookie from 'vue-cookie';
import Translate from '@/components/Translate.vue';

export default {
    name: 'ClickAndBuyForm',
    components: {
        Translate,
        SwitchButton,
        ClickAndBuyMediaForm,
        CurrencyInput,
        LabelWithError,
        Icon,
        ErrorMessage,
        TextField,
        Button,
        SuccessMessage,
        VueEditor,
    },
    props: {
        id: String,
        modalId: String,

        settings: Object,

        clickAndBuy: {
            id: String,

            title: String,
            text: String,

            emailText: String,
            mediaFileId: String,

            articleFileId: String,
            price: Number,

            disabled: Boolean,
        },
        disabled: Boolean,
    },
    data() {
        return {
            trigger: 0,
            title: 'clickandbuy',

            loading: false,
            success: false,
            error: null,

            validationTrigger: 0,

            newClickAndBuy: this.clickAndBuy,
            newMediaFileId: this.clickAndBuy.mediaFileId,

            clickAndBuyFile: this.clickAndBuy.articleFileId,
            clickAndBuyFileError: null,

            titleField: {
                value: this.clickAndBuy.title,
                valid: !!this.clickAndBuy.title,

                name: 'title',
                label: 'title',
                icon: 'hashtag',
                rules: 'required|max:64',
            },

            priceField: {
                value: this.clickAndBuy.price,
                valid: true,

                name: 'price',
                label: 'price',
                icon: 'tag',
                rules: '',
                type: 'number',
                steps: 0.01,
            },

            fileError: null,

            deleteError: null,
            deleteSuccess: false,
            deleteLoading: false,

            isActive: !this.clickAndBuy.disabled,
        };
    },
    computed: {
        computedCurrencyOptions() {
            return {
                currency: this.getInfos.currency,
                currencyDisplay: 'symbol',
                valueRange: {
                    min: 0,
                },
                precision: 2,
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: false,
                useGrouping: true,
                accountingSign: false,
            };
        },
    },
    methods: {
        setMediaFile(file) {
            this.newMediaFileId = file;
        },
        setValid(valid) {
            this.success = false;
            this.titleField.valid = valid;
        },
        actionFileTriggerInput() {
            document.getElementById('clickandbuy-file' + this.id).click();
        },
        actionArticleFileDownload() {
            event.preventDefault();

            if (
                this.newClickAndBuy.articleFileId &&
                this.newClickAndBuy.articleFileId.name
            ) {
                let blob = this.newClickAndBuy.articleFileId;
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = this.newClickAndBuy.articleFileId.name;
                link.click();
                return;
            }

            let self = this;
            self.download = true;

            let request = new XMLHttpRequest();
            request.open(
                'GET',
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    self.newClickAndBuy.id +
                    '/article/' +
                    this.newClickAndBuy.articleFileId,
                true
            );
            request.responseType = 'blob';
            request.onload = function () {
                let blob = request.response;
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = self.newClickAndBuy.articleFileId;
                link.click();

                self.loadingDowload = false;
            };

            request.setRequestHeader('token', VueCookie.get('token'));
            request.send();
        },
        actionFileDelete() {
            this.newClickAndBuy.articleFileId = null;
        },
        actionDelete() {
            this.deleteLoading = true;

            let http = axios.create();
            http.delete(
                this.apiUrl + '/manage-clickandbuys/' + this.newClickAndBuy.id
            )
                .then(() => {
                    this.deleteError = null;
                    this.deleteSuccess = true;
                    this.deleteLoading = false;

                    UIkit.modal('#' + this.modalId).hide();

                    if (this.clickAndBuy.id) {
                        this.$emit('declared', this.clickAndBuy.id);
                    }

                    UIkit.notification({
                        message: this.$t('clickandbuy.deleted.message'),
                        status: 'info',
                        pos: 'top-center',
                        timeout: this.notificationTimeout,
                    });
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.deleteError = e;
                    this.deleteSuccess = false;
                    this.deleteLoading = false;
                });
        },
        actionDeclare() {
            this.validationTrigger++;

            if (!this.titleField.valid) {
                return;
            }

            if (this.newClickAndBuy.id) {
                return this.actionUpdate();
            }

            return this.actionCreate();
        },
        fileHandleDrop() {
            let files = this.$refs['clickandbuyfile' + this.id].files;

            const file = files[0];

            if (
                file.size > this.settings.clickAndBuyInfos.articleFileSizeBytes
            ) {
                this.clickAndBuyFileError = this.$t('file.size.error', {
                    x: this.settings.clickAndBuyInfos.articleFileSizeBytes,
                });
                return;
            }

            this.newClickAndBuy.articleFileId = file;
        },
        actionCreate() {
            this.loading = true;

            let http = axios.create();
            http.post(this.apiUrl + '/manage-clickandbuys', {
                title: this.titleField.value,
                text: this.newClickAndBuy.text,

                emailText: this.newClickAndBuy.emailText,
                price: this.priceField.value,

                disabled: !this.isActive,
            })
                .then((response) => {
                    this.actionDeclareMediaFile(response.data.id);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionUpdate() {
            this.loading = true;

            let http = axios.create();
            http.patch(
                this.apiUrl + '/manage-clickandbuys/' + this.newClickAndBuy.id,
                {
                    title: this.titleField.value,
                    text: this.newClickAndBuy.text,

                    emailText: this.newClickAndBuy.emailText,
                    price: this.priceField.value,

                    disabled: !this.isActive,
                }
            )
                .then(() => {
                    this.actionDeclareMediaFile();
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionDeclareMediaFile(id) {
            let targetId = this.newClickAndBuy.id;
            if ((!targetId || targetId === 'new') && id) {
                targetId = id;
            }

            if (this.newMediaFileId && !this.newMediaFileId.name) {
                this.actionDeclareArticleFile();
                return;
            }

            let formData = new FormData();
            formData.append('mediaFile', this.newMediaFileId);

            this.loading = true;

            let http = axios.create();
            http.put(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/media-file',
                formData
            )
                .then(() => {
                    this.actionDeclareArticleFile(targetId);
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
        actionDeclareArticleFile(id) {
            let targetId = this.newClickAndBuy.id;
            if ((!targetId || targetId === 'new') && id) {
                targetId = id;
            }

            if (
                this.newClickAndBuy.articleFileId &&
                !this.newClickAndBuy.articleFileId.name
            ) {
                this.error = null;
                // this.success = true;
                this.loading = false;
                UIkit.modal('#' + this.modalId).hide();

                if (targetId) {
                    this.$emit('declared', targetId);
                }

                UIkit.notification({
                    message: this.$t('clickandbuy.updated.message'),
                    status: 'info',
                    pos: 'top-center',
                    timeout: this.notificationTimeout,
                });
                return;
            }

            let formData = new FormData();
            formData.append('articleFile', this.newClickAndBuy.articleFileId);

            this.loading = true;

            let http = axios.create();
            http.put(
                this.apiUrl +
                    '/manage-clickandbuys/' +
                    targetId +
                    '/article-file',
                formData
            )
                .then(() => {
                    this.error = null;
                    // this.success = true;
                    this.loading = false;
                    UIkit.modal('#' + this.modalId).hide();

                    this.$emit('declared', targetId);

                    UIkit.notification({
                        message: this.$t('clickandbuy.updated.message'),
                        status: 'info',
                        pos: 'top-center',
                        timeout: this.notificationTimeout,
                    });
                })
                .catch((e) => {
                    this.checkGenericError(e);

                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.file-name {
    margin-top: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.clickandbuy-file {
    max-width: 30px;
    max-height: 30px;
}

.clickandbuy-file-struct {
    width: 100%;
}
</style>
